<div class="flex flex-col h-screen">
  @if (!isNativeApp) {
    <lib-navigation></lib-navigation>
  }

  <router-outlet></router-outlet>
</div>
